<script lang="ts">
    import { onDestroy } from 'svelte'

    import Icon from '@iconify/svelte'

    import type { CrumbArray, Crumbs, CrumbsStore } from 'hydria/components/breadcrumb'
    import { tgettext as _, resolve } from 'hydria/services/gettext'
    import { signedIn } from 'hydria/services/session'
    import { sanchor } from 'hydria/svelte_helpers'

    const unsubs: any[] = []
    onDestroy(() => {
        for (const unsub of unsubs) unsub.unsubscribe != null ? unsub.unsubscribe() : unsub()
    })

    interface Props {
        // Incoming items is either a list of ICrumb, or a Svelte store containing such a list
        crumbs?: Crumbs
        class?: string
    }

    let { crumbs = [], class: _class = '' }: Props = $props()

    const mode: 'store' | 'raw' = (crumbs as CrumbsStore).subscribe != null ? 'store' : 'raw'

    // Typecast crumbs into a store
    // let witems: CrumbsReadableStore = (crumbs as CrumbsStore).subscribe != null ? (crumbs as CrumbsStore) : readable(crumbs as CrumbArray)
    // const parts: CrumbsReadableStore = sderived(witems, (witems: CrumbArray) => [...witems.filter((crumb) => !crumb.extra), ...witems.filter((crumb) => crumb.extra)])

    let witems: CrumbArray = $state([])

    if (mode == 'store') {
        unsubs.push(
            (crumbs as CrumbsStore).subscribe((v: CrumbArray) => {
                witems = v
            }),
        )
    } else {
        $effect(() => {
            witems = crumbs as CrumbArray
        })
    }

    let parts: CrumbArray = $derived([...witems.filter((crumb) => !crumb.extra), ...witems.filter((crumb) => crumb.extra)])

    const asAny = (x: any) => x as any
</script>

<style>
    nav {
        margin-bottom: 1.5rem;
    }

    nav > .card-body {
        padding: 0.75rem 1rem;
    }

    nav ol {
        display: flex;
        flex-wrap: wrap;
        padding: 0;
        margin-bottom: 0;
        font-size: var(--hy-crumb-font-size);
        list-style: none;
        border-radius: var(--hy-crumb-border-radius);
        align-items: center;
    }
    nav ol .item + .item::before,
    nav ol .extra + .extra::before {
        /* Suppress inline spacings and underlining of the separator */
        float: left;
        padding: 0 var(--hy-crumb-item-pad-x);
        color: var(--hy-crumb-divider-color);
    }
    nav ol .item.active {
        color: var(--hy-crumb-active-color);
    }
    nav ol .fill {
        flex: 1 0 0;
    }
    nav ol .item + .item::before {
        content: '/';
    }
    nav ol .extra:not(.simple-extra) + .extra::before {
        /* A "middle dot", very subtle */
        content: '\b7';
    }
    nav ol .extra.simple-extra + .extra {
        margin-left: 0.25rem;
    }
</style>

{#if $signedIn}
    <nav class="d-print-none" aria-label="breadcrumb">
        <ol class="breadcrumb{_class ? ` ${_class}` : ''}">
            {#each parts as item, i}
                {#if item.extra && i > 0 && !parts[i - 1].extra}
                    <li class="fill"></li>
                {/if}
                <li class:item={!item.extra} class:extra={item.extra} class:simple-extra={item.extra === 'simple'}>
                    {#if item.icon != null}<Icon inline icon={item.icon} />{/if}
                    <span
                        >{#if item.button != null}
                            <button class={item.urlClasses ? item.urlClasses : 'btn btn-outline-secondary'} onclick={() => asAny(item).button()}
                                >{#if item.html}{@html $resolve(item.txt)}{:else}{$resolve(item.txt)}{/if}</button
                            >
                        {:else if item.url != null && (i < parts.length - 1 || item.extra)}
                            <a href={item.url} class={item.urlClasses ? item.urlClasses : ''} use:sanchor
                                >{#if item.html}{@html $resolve(item.txt)}{:else}{$resolve(item.txt)}{/if}</a
                            >
                        {:else if item.html != null}
                            <span>{@html $resolve(item.txt)}</span>
                        {:else}
                            <span>{$resolve(item.txt)}</span>
                        {/if}</span
                    >
                </li>
            {/each}
        </ol>
    </nav>
{/if}
